import React, { Component } from "react";
import ButtonSave from "../Button/ButtonSave";
import ButtonPurchase from "../Button/ButtonPurchase";
import CartTotals from "../CartTotals";
import ButtonEdit from "../Button/ButtonEdit";
import ButtonMarket from "../Button/ButtonMarket";
import {URL_SERVER, TYPE_NEXT_SAVE, TYPE_NEXT_PURCHASE} from "../../const";

export default class Header extends Component {
  render() {
    return (
      <header className="header">
        <div className="container">
          <div className="header_wrap">
            <div className="header_left">
              <div className="header_logo">
                <h1>
                  <a href={URL_SERVER} target="_balnk">
                    <img src="/img/PASRAL_new.png" alt="Pasral tool" />
                  </a>
                </h1>
              </div>
              <div className="logo_title hidden_sp">
                <h2>オリジナルパワーストーンの </h2>
                <h2>作成・販売</h2>
              </div>
            </div>
            <div className="header_right hidden_sp">
              <div className="header_action">
                <CartTotals {...this.props} />
                <div className="header_btn">
                  <ButtonPurchase {...this.props} typeButtonSave = {TYPE_NEXT_SAVE} />
                  <ButtonPurchase {...this.props} typeButtonSave = {TYPE_NEXT_PURCHASE} />
                </div>
              </div>
            </div>
            <div className="header_right show_sp">
              <div className="header_action">
                {/*<ButtonMarket {...this.props} />*/}
                {/*<ButtonEdit {...this.props} />*/}
                <ButtonPurchase {...this.props} typeButtonSave = {TYPE_NEXT_PURCHASE} />
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
